import React, { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Router from "./config/RouterConfig";
import { initialAppOptions } from "./store/AuthSlice";
import { setTranslationLanguage  } from "./store/CommonSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./store/app";
import PageSpinner from "./components/PageSpinner/PageSpinner";
import { getStatus } from "./views/webPages/HomePage/utils/slice";
import GoogleTranslator from "./components/GoogleTranslateElement/GoogleTranslator";
import { set } from "lodash";
function App() {
  const dispatch: AppDispatch = useDispatch();
  const AUTH = useSelector((state: RootState) => state.AUTH);
  const translation = useSelector((state: RootState) => state.COMMON.translation);
  const translationLanguage = useSelector((state: RootState) => state.COMMON.translationLanguage);

  // const location = useLocation();
  const autofilledInputs = document.querySelectorAll('input:-webkit-autofill');
  if (autofilledInputs.length > 0) {

    // console.log("Autofill detected on these fields:", autofilledInputs);
    autofilledInputs.forEach(input => {
      const formitem: any = input.closest('.ecn-input');
      const inputRow = formitem.querySelector('.ant-form-item-row');
      inputRow.classList.add('focused');
    });
  }


  useEffect(() => {



    dispatch(initialAppOptions()).catch((error: any) => error);

    dispatch(getStatus("homepage")).catch((error: any) => error);
  }, [dispatch]);


  // useEffect(() => {
  // console.log("Route changed to:", location.pathname);
  // }, [window.location]);

  const setLanguage = (lang: string) => {
    // alert(lang);
    dispatch(setTranslationLanguage(lang));
  }



  return (
    <>
      <BrowserRouter >
        <GoogleTranslator language={translationLanguage} setLanguage={setLanguage} show={translation.show} className={translation.className} />
        {AUTH.appLoading ? <PageSpinner /> : <Router />}
      </BrowserRouter>
    </>
  )
}

export default App
